import st from "./index.module.css";
import Img from "../../components/Image";

const TextImageVert = () => {
  return (
    <div className={st.container}>
      <div className={st.contentContainer}>
        <div className={st.mainCont}>
          <span id={st.mainhead}>Putting People First Breaks Records</span>
          <span id={st.para}>
            SwissBorg's Series A is a unique opportunity to invest in a company
            at an early stage.The valuation will change depending on expressed
            interest during Series A. More than 12,000 people have already
            invested making SwissBorg Series A one of the largest crowdfundings.
          </span>
          <div className={st.imgCont}>
            <Img src="https://firebasestorage.googleapis.com/v0/b/nexusconnects-bfe18.appspot.com/o/aidtaasImages%2Fimages%2FtextImageVert%2Fimg.webp?alt=media&token=88c0340c-958b-4ae6-900f-e5d71d3337ec" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextImageVert;
